import { useRef, useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

const EMPTY_STATE = {}
const STICKY_AUTH_DISABLED = process.env.REACT_APP_STICKY_AUTH_STATE === 'false'

const useAuthState = (oktaAuthState) => {
  const lastValidState = useRef(null)

  return useMemo(() => {
    if (!isEmpty(oktaAuthState)) {
      lastValidState.current = oktaAuthState
      return oktaAuthState
    }

    if (!STICKY_AUTH_DISABLED && lastValidState.current) {
      console.debug('useAuthState: transitional gap detected, holding previous auth state')
      return lastValidState.current
    }

    return EMPTY_STATE
  }, [oktaAuthState])
}

export default useAuthState
